import Vue from 'vue';
import { gsap, Quint, Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('faq-component', {
    data() {
        return {

        };
    },

    mounted() {
        EventBus.$once('page-transition-enter-complete', this.reveal);
    },

    methods: {
        /**
         * Toggles the faq active state
         *
         * @param {Event} event
         */
        toggleFaq(event) {
            const faqItem = event.currentTarget.parentElement;
            const faqItemText = event.currentTarget.nextElementSibling;

            if (faqItem.classList.contains('active')) {
                faqItem.classList.remove('active');
                gsap.to(faqItemText, {
                    duration: 1,
                    height: 0,
                    ease: Quint.easeOut,
                });
            } else {
                faqItem.classList.add('active');
                gsap.to(faqItemText, {
                    duration: 1,
                    height: 'auto',
                    ease: Quint.easeOut,
                });
            }
        },

        reveal() {
            const elements = [...document.querySelectorAll('.faq-container')];

            elements.forEach((element, index) => {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: element,
                        start: "top 88%",
                        onEnter: () => {
                            gsap.to('.faq__item', { duration: 0.5, y: '0', autoAlpha: 1, ease: Power3.ease, stagger: 0.1 });
                        }
                    },
                });
            });
        },
    },
});